import {Typography} from '@mui/material';
import {AlertInfo} from 'presentation/components';
import React from 'react';

import {useQueryParams} from 'presentation/pages';
import {translations} from 'presentation/translations-new';

const {examAlert} = translations['pt-br'].privateFlow.guideFlow;

export const ExamAlert = () => {
	const {
		SEARCH_PARAMS: {specialtyName},
	} = useQueryParams();

	const [alertDescriptionBefore, alertDescriptionAfter] =
		examAlert.description.split('$procedure');

	return (
		<AlertInfo.Root sx={{borderRadius: 0}}>
			<AlertInfo.Description>
				<Typography variant="body2">
					{alertDescriptionBefore}
					<b>{specialtyName}</b>
					{alertDescriptionAfter}
				</Typography>
			</AlertInfo.Description>
		</AlertInfo.Root>
	);
};
